import React from 'react';
import PropTypes from 'prop-types';

import './ClassesStudentsCard.scss';

const ClassesStudentsAddCard = props => (
  <a className="card add-new classes-students-card" onClick={props.onClick}>
    <span>
      <div className="add-icon">
        <i className="ti-plus" />
      </div>
      Adicionar Turma
    </span>
  </a>
);

ClassesStudentsAddCard.propTypes = {};

export default ClassesStudentsAddCard;
